module.exports = __webpack_public_path__ + "img/rate-active.48d65ea9.svg";